// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__zcK0w","question":"Question_question__2g25Q","description":"Question_description__U5f4p"};